// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4964":"6a8df43926aa0031","7639":"1d9bc8ef020e61c9"}[chunkId] + ".css";
};